import { css } from 'css-literal-loader/styled';
import React from 'react';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import Layout from '@4c/layout';

import iPadLightning from '../assets/iPad-Lightning.png';
import iPhoneX from '../assets/iPhone-X.png';
import iPadUsbc from '../assets/iPad-USB-C.png';
import iQ from '../assets/iQ-top.png';

import PageSegment from './PageSegment';
import Responsive from './Responsive';
import Text from './Text';

const messages = defineMessages({
  iQAlt: {
    id: 'compatibility.image.iQ',
    defaultMessage: 'Butterfly iQ',
  },
  badgeNew: {
    id: 'compatibility.badge.new',
    defaultMessage: 'New',
  },
  iPadLightningAlt: {
    id: 'compatibility.image.iPad.lightning',
    defaultMessage: 'iPad with lightning connection',
  },
  iPhoneLightningAlt: {
    id: 'compatibility.image.iPhone.lightning',
    defaultMessage: 'iPhone with lightning connection',
  },
  iPadUsbcAlt: {
    id: 'compatibility.image.iPhone.usbc',
    defaultMessage: 'iPad with USB-C connection',
  },
  compatibilityListLightningDevice: {
    id: 'compatibility.list.lightning.device.name',
    defaultMessage: 'Butterfly iQ (Lightning)',
  },
  compatibilityListUsbcDevice: {
    id: 'compatibility.list.usbc.device.name',
    defaultMessage: 'Butterfly iQ (USB-C)',
  },
  compatibilityDevicesListHeader: {
    id: 'compatibility.list.header',
    defaultMessage: 'Compatible with:',
  },
  compatibilityListLightningIPad: {
    id: 'compatibility.list.lightning.iPad',
    defaultMessage:
      'iPad 5th generation (2017), Pro 12.9-inch 1st or 2nd generation, Pro 9.7-inch, Pro 10.5-inch',
  },
  compatibilityListLightningIPhone: {
    id: 'compatibility.list.lightning.iPhone',
    defaultMessage:
      'iPhone 6s, 6s Plus, SE, 7, 7 Plus, 8, 8 Plus, X, XS, XS Max, XR',
  },
  compatibilityListUsbc: {
    id: 'compatibility.list.usbc',
    defaultMessage: 'iPad Pro 12.9-inch (3rd generation), Pro 11-inch',
  },
  compatibilitySpecsListHeader: {
    id: 'compatibility.list.specs.header',
    defaultMessage: 'Specs:',
  },
  compatibilityListSpecsLightning: {
    id: 'compatibility.list.specs.lightning',
    defaultMessage: '1.25m cord length',
  },
  compatibilityListSpecsUsbc: {
    id: 'compatibility.list.specs.lightning',
    defaultMessage: '2m cord length',
  },
});

const styles = require('./CompatibilitySegment-styles.module.scss');

function CompatibilitySegment({ intl }) {
  return (
    <PageSegment theme="white" align="center" name="compatibility">
      <PageSegment.Heading>
        <FormattedMessage
          id="compatibility.title"
          defaultMessage="Compatibility."
        />
      </PageSegment.Heading>
      <Responsive mdDown>
        {isMediumDown => (
          <>
            <Layout
              justify="center"
              align="center"
              className={styles.segmentDesktop}
            >
              <Layout
                direction={isMediumDown ? 'column' : 'row'}
                justify="center"
                align="flex-start"
              >
                <div className={styles.skuContent}>
                  <Layout
                    direction="row"
                    align="flex-end"
                    justify="center"
                    className={styles.lightningImages}
                  >
                    <div>
                      <img
                        src={iPadLightning}
                        className={styles.iPadLightning}
                        alt={intl.formatMessage(messages.iPadLightningAlt)}
                      />
                    </div>
                    <div>
                      <img
                        src={iPhoneX}
                        className={styles.iPhoneX}
                        alt={intl.formatMessage(messages.iPhoneLightningAlt)}
                      />
                    </div>
                    <Responsive lgDown>
                      {isLargeDown =>
                        !isLargeDown && (
                          <div>
                            <img
                              src={iQ}
                              className={styles.iQ}
                              alt={intl.formatMessage(messages.iQAlt)}
                            />
                          </div>
                        )
                      }
                    </Responsive>
                  </Layout>
                  <PageSegment.Heading>
                    <FormattedMessage
                      {...messages.compatibilityListLightningDevice}
                    />
                  </PageSegment.Heading>
                  <div className={styles.skuBody}>
                    <Text level="2" bold>
                      <FormattedMessage
                        {...messages.compatibilityDevicesListHeader}
                      />
                    </Text>
                    <ul className={styles.compatibilityList}>
                      <li className={styles.compatibilityItem}>
                        <FormattedMessage
                          {...messages.compatibilityListLightningIPad}
                        />
                      </li>
                      <li className={styles.compatibilityItem}>
                        <FormattedMessage
                          {...messages.compatibilityListLightningIPhone}
                        />
                      </li>
                    </ul>

                    <Text level="2" bold>
                      <FormattedMessage
                        {...messages.compatibilitySpecsListHeader}
                      />
                    </Text>
                    <ul className={styles.compatibilityList}>
                      <li className={styles.compatibilityItem}>
                        <FormattedMessage
                          {...messages.compatibilityListSpecsLightning}
                        />
                      </li>
                    </ul>
                  </div>
                </div>
                <div className={styles.skuContent}>
                  <Layout direction="row" align="flex-end" justify="center">
                    <Layout
                      direction="row"
                      align="flex-end"
                      justify="center"
                      className={styles.usbcImages}
                    >
                      <div>
                        <img
                          src={iPadUsbc}
                          className={styles.iPadUsbc}
                          alt={intl.formatMessage(messages.iPadUsbcAlt)}
                        />
                      </div>
                      <div className={styles.iPadUsbcOther}>
                        <img
                          src={iPadUsbc}
                          className={styles.iPadUsbcOther}
                          alt={intl.formatMessage(messages.iPadUsbcAlt)}
                        />
                      </div>
                      <Responsive lgDown>
                        {isLargeDown =>
                          !isLargeDown && (
                            <div>
                              <img
                                src={iQ}
                                className={styles.iQ}
                                alt={intl.formatMessage(messages.iQAlt)}
                              />
                            </div>
                          )
                        }
                      </Responsive>
                    </Layout>
                  </Layout>
                  <Layout
                    align="center"
                    justify="flex-start"
                    className={styles.badgeNew}
                  >
                    <span>
                      <FormattedMessage {...messages.badgeNew} />
                    </span>
                  </Layout>
                  <PageSegment.Heading className={styles.usbcDeviceHeading}>
                    <FormattedMessage
                      {...messages.compatibilityListUsbcDevice}
                    />
                  </PageSegment.Heading>
                  <div className={styles.skuBody}>
                    <Text level="2" bold>
                      <FormattedMessage
                        {...messages.compatibilityDevicesListHeader}
                      />
                    </Text>
                    <ul className={styles.compatibilityList}>
                      <li className={styles.compatibilityItem}>
                        <FormattedMessage
                          {...messages.compatibilityListUsbc}
                        />
                      </li>
                    </ul>
                    <Text level="2" bold>
                      <FormattedMessage
                        {...messages.compatibilitySpecsListHeader}
                      />
                    </Text>
                    <ul className={styles.compatibilityList}>
                      <li className={styles.compatibilityItem}>
                        <FormattedMessage
                          {...messages.compatibilityListSpecsUsbc}
                        />
                      </li>
                    </ul>
                  </div>
                </div>
              </Layout>
            </Layout>
          </>
        )}
      </Responsive>
    </PageSegment>
  );
}

export default injectIntl(CompatibilitySegment);
